"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ControlLabel extends _react.default.PureComponent {
  render() {
    const {
      text,
      id,
      aside,
      optional,
      themeLabel
    } = this.props;
    const labelClasses = `inline-block ${themeLabel}`;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id,
      className: labelClasses
    }, text, " ", optional && /*#__PURE__*/_react.default.createElement("span", {
      className: "txt-normal"
    }, "(optional)")), aside && /*#__PURE__*/_react.default.createElement("span", {
      className: "inline-block ml12"
    }, aside));
  }

}

exports.default = ControlLabel;

_defineProperty(ControlLabel, "propTypes", {
  /** Label text */
  text: _propTypes.default.string.isRequired,

  /** Value should match the identifying id of the input element. */
  id: _propTypes.default.string.isRequired,

  /** Additional content to provide aligned to the right of the label. */
  aside: _propTypes.default.node,

  /** If true, label text adds (optional) alongside it. */
  optional: _propTypes.default.bool,

  /** A space separated list of Assembly class names to override the existing presentation. */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlLabel, "defaultProps", {
  themeLabel: 'txt-s txt-bold mb6'
});